import { IMaterialTypeFormValues } from './materialTypeFormValues';
import { z } from 'zod';
import { baseModelSchema } from '../../baseModel';

/**
 * Zod schema for validating material type data.
 * Extends the base model schema with material type-specific fields.
 *
 * @property {string} name - Name of the material type (max 255 characters)
 * @property {boolean} isPackType - Whether this material type is used for packing
 */
export const materialTypeSchema = baseModelSchema.extend({
    name: z.string().nonempty('Name is required').max(255, 'Name can only be up to 255 characters long.').default(''),
    isPackType: z.boolean().default(false),
});

/**
 * TypeScript interface representing a Material Type object.
 * Generated from the Zod schema for type safety.
 */
export type IMaterialType = z.infer<typeof materialTypeSchema>;

/**
 * Creates a validated Material Type object from form values.
 *
 * @param {IMaterialTypeFormValues} formValues - The form data to convert
 * @returns {IMaterialType} A validated material type object
 * @throws {ZodError} If validation fails
 */
export function MaterialType(formValues : IMaterialTypeFormValues) : IMaterialType {
    return materialTypeSchema.parse({
        ...formValues,
    });
};
